import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, FileText, Shield, Zap } from 'lucide-react';
import SeoMeta from '../components/SeoMeta';
import BookingComponent from '../components/BookingComponent';

const PruebaGratisPage = () => {
  const { t, i18n } = useTranslation(['trial', 'common']);

  return (
    <div className="min-h-screen bg-white">
      <SeoMeta
        title={t('trial:seo-title')}
        description={t('trial:seo-description')}
        canonical="https://bluecmr.com/periodo-prueba"
      />

      {/* Hero */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {t('trial:title')}
          </h1>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            {t('trial:subtitle')}
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <div className="flex items-center gap-2 bg-white/80 px-4 py-2 rounded-full">
              <CheckCircle className="w-4 h-4 text-blue-600" />
              <span>{t('trial:badge-1')}</span>
            </div>
            <div className="flex items-center gap-2 bg-white/80 px-4 py-2 rounded-full">
              <CheckCircle className="w-4 h-4 text-blue-600" />
              <span>{t('trial:badge-2')}</span>
            </div>
            <div className="flex items-center gap-2 bg-white/80 px-4 py-2 rounded-full">
              <CheckCircle className="w-4 h-4 text-blue-600" />
              <span>{t('trial:badge-3')}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Left - Features */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">{t('trial:includes-title')}</h2>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <FileText className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('trial:feature-documents')}</h3>
                    <p className="text-gray-600">{t('trial:feature-documents-desc')}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Shield className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('trial:feature-signature')}</h3>
                    <p className="text-gray-600">{t('trial:feature-signature-desc')}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Zap className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">{t('trial:feature-ready')}</h3>
                    <p className="text-gray-600">{t('trial:feature-ready-desc')}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Booking */}
            <div>
              <div className="bg-white border border-gray-200 rounded-lg p-8 shadow-sm">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">{t('trial:form-title')}</h2>
                <p className="text-gray-600 mb-6">{t('trial:form-subtitle')}</p>
                <BookingComponent
                  bookingToken="2719ff77-7a99-47a7-b9cd-8a32161ef920"
                  locale={i18n.language}
                  source="trial"
                />
              </div>
            </div>
          </div>

          {/* Pilot program */}
          <div className="mt-12 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-8 border border-blue-100">
            <h3 className="text-xl font-bold text-gray-900 mb-2">{t('trial:pilot-title')}</h3>
            <p className="text-gray-600">{t('trial:pilot-desc')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PruebaGratisPage;
